import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { ChatService } from 'app/services/chat-service';

declare function resetChat(): any;
declare function desloadChat(): any;

@Injectable()
export class LogoutGuard implements CanActivate {

    constructor(private authService: AuthService, private chatService: ChatService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        this.authService.logout();

        // Va antes que resetChat() a proposito: esa funcion es del chat antiguo (Chatwoot) y
        // lanza TypeError porque window.$chatwoot ya no existe, asi que todo lo que se ponga
        // detras no llega a ejecutarse.
        this.chatService.destroyWidget();

        resetChat();
        desloadChat();
        return false;
    }
}
